// Modelo Compañia para administrador.
export default class Anexo {
    id=""
    description=""
    group=""
    year=""
    file=""
    filePath=""
    fileName=""
    fileType=""
    date=""
    diagnostics=[]
    patientRouteSheet=""
}



// WEBPACK FOOTER //
// ./src/model/Anexo.js